import { render, staticRenderFns } from "./DeletePatient.vue?vue&type=template&id=5c0b4b7e&scoped=true"
import script from "./DeletePatient.vue?vue&type=script&lang=js"
export * from "./DeletePatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0b4b7e",
  null
  
)

export default component.exports